import { takeLatest, call, put } from 'redux-saga/effects'
import lessonBlocksList from 'api/administration/blocks/List'
import { editSessionBlock } from 'api/administration/blocks/Edit'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import { getBrowserTimezone } from 'helpers/timezone.helper'
import { ISessionBlockEditModel } from 'models/block.model'
import * as fromActions from '../../../actions/blocks.action'
import { EditSessionBlockPayload } from '../../../actions/blocks.action'

async function getList(lessonId: number) {
  return lessonBlocksList(lessonId)
}
async function editSession(
  blockId: number,
  blockDetails: ISessionBlockEditModel
) {
  return editSessionBlock(blockId, blockDetails)
}

const pattern = fromActions.EDIT_SESSION_BLOCK

function* editSessionBlockEffectSaga(
  action: ActionWithPayload<typeof pattern, EditSessionBlockPayload>
) {
  try {
    const {
      payload: { id, lessonId, name, description, sessions },
    } = action

    const blockDetails: ISessionBlockEditModel = {
      block_session: {
        name,
        description,
        timezone: getBrowserTimezone(),
        sessions,
      },
      block_instance: {
        lesson_id: lessonId,
        name,
        description,
      },
    }
    yield call(editSession, id, blockDetails)
    const data = yield call(getList, lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editSessionBlockWatcherSaga() {
  yield takeLatest(pattern, editSessionBlockEffectSaga)
}
